import * as fromDatatype from '../datatype-library/index';

export interface bl_pgw_payment_channel_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.GuidDataFieldInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_pgw_payment_channel_ext_RowClass implements bl_pgw_payment_channel_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldClass;
  hdr_guid: fromDatatype.GuidDataFieldClass;
  ext_type: fromDatatype.VarcharDatatypeClass;
  ext_code: fromDatatype.VarcharDatatypeClass;
  ext_option: fromDatatype.VarcharDatatypeClass;
  property_json: fromDatatype.JsonDatatypeClass;
  param_code: fromDatatype.VarcharDatatypeClass;
  param_name: fromDatatype.VarcharDatatypeClass;
  param_type: fromDatatype.VarcharDatatypeClass;
  value_string: fromDatatype.VarcharDatatypeClass;
  value_file: fromDatatype.GuidDataFieldClass;
  value_numeric: fromDatatype.NumericDatatypeClass;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeClass;
  created_by_subject_guid: fromDatatype.GuidDataFieldClass;
  updated_by_subject_guid: fromDatatype.GuidDataFieldClass;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldClass;
  revision: fromDatatype.RevisionDataFieldClass;
  vrsn: fromDatatype.VrsnDataFieldClass;

}
